import React from 'react'

import { Route } from 'react-router'

import config from 'config/routes'
import { FullPage } from 'layouts/FullPage'

import { PaidSearchBrandPage } from './PaidSearchBrandPage'

export const PaidSearchBrand = (
  <Route
    component={FullPage}
    props={{
      footerIsOnLandingPage: true,
      showHeaderWithoutNavLink: true,
      hasLoginModal: true,
    }}
  >
    <Route path={config.client.paidSearchBrand} component={PaidSearchBrandPage} />
  </Route>
)
